module.exports = __webpack_public_path__ + "media/site/images/icons/mobile-app-icon-756763e646c1a53af80a8eae66229072.svg";